import { RootState } from 'typesafe-actions';

export const filterSelector = (state: RootState) => state.user.assignClient.filter;

export const assignClientItemsSelector = (state: RootState) => state.user.assignClient.items;

export const assignClientLoadingSelector = (state: RootState) => state.user.assignClient.loading;

export const assignClientErrorSelector = (state: RootState) => state.user.assignClient.error;
